<script lang="ts">
  import { onMount, onDestroy } from 'svelte'
  import { writable } from 'svelte/store'

  const isOffline = writable(false);

  onMount(() => {
    // ✅ This code only runs in the browser
    isOffline.set(!navigator.onLine);

    const updateStatus = () => {
      isOffline.set(!navigator.onLine);
    };

    window.addEventListener('online', updateStatus);
    window.addEventListener('offline', updateStatus);

    onDestroy(() => {
      window.removeEventListener('online', updateStatus);
      window.removeEventListener('offline', updateStatus);
    });
  });
</script>

{#if $isOffline}
  <div
    class="fixed top-0 left-0 w-full bg-red-600 text-white text-center py-2 z-[9999] shadow-md animate-fade-in"
    role="alert"
  >
    You’re offline. Some features may not work.
  </div>
{/if}

<style lang="postcss">
  @keyframes fade-in {
    from {
      opacity: 0;
      transform: translateY(-100%);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .animate-fade-in {
    animation: fade-in 0.3s ease-out forwards;
  }
</style>
